import { render, staticRenderFns } from "./AboutGranja.vue?vue&type=template&id=78a24b00&scoped=true"
var script = {}
import style0 from "./AboutGranja.vue?vue&type=style&index=0&id=78a24b00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a24b00",
  null
  
)

export default component.exports